import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import { GetterTypes } from "@/store";
import { useComputedValue } from "@/composables";
import { getLanguage } from "@/utils/api";
import { AppEnvironment, LayoutTypes } from "@/store/app/state";
import { computed } from "vue";

const pathPrefix = "/banners/banner";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileInstallationBanner',
  setup(__props) {

const initialLoad = useComputedValue(GetterTypes.GET_CHATS_INITIAL_LOAD);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const language = getLanguage();
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isIos = computed(() => environment.value.isIos);
const isShown = computed(
  () =>
    initialLoad &&
    !environment.value.isMobileApp &&
    layoutType.value === LayoutTypes.MOBILE,
);

const googlePlayStore = process.env.VUE_APP_ANDROID_INSTALL_LINK;
const appleStore = process.env.VUE_APP_IOS_INSTALL_LINK;

const getLink = () => {
  return isIos.value ? appleStore : googlePlayStore;
};

const os = isIos.value ? "appstore" : "playstore";
const bannerSrc = `${pathPrefix}-${os}-${language}.jpg`;

return (_ctx: any,_cache: any) => {
  return (isShown.value && isIos.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: getLink(),
        target: "_blank",
        rel: "noopener noreferer",
        class: "banner"
      }, [
        _createElementVNode("img", {
          class: "img",
          src: bannerSrc,
          alt: "mobile_installation_banner"
        })
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})